// dataset.store.ts
import { Injectable, computed, signal } from '@angular/core';
import { ListModel } from '@models/music.model';

@Injectable({ providedIn: 'root' })
export class DataStore {

    /** Stato “lists” condiviso in tutta l’app */
    private readonly _lists = signal<ListModel | null>(null);

    /** View readonly */
    readonly lists = computed(() => this._lists());
    readonly authors = computed<string[]>(() => this._lists()?.authors ?? []);
    readonly keys = computed<string[]>(() => this._lists()?.keys ?? []);

    /** Set completo dal resolver (sovrascrive) */
    setListsFromResolver(lists: ListModel) {
        this._lists.set(lists);
    }

    /** Merge parziale se il resolver restituisce solo una parte delle liste */
    mergeListsFromResolver(partial: Partial<ListModel>) {
        this._lists.update(curr => ({ ...(curr ?? {} as ListModel), ...partial } as ListModel));
    }

    /** Aggiungi autore (idempotente) */
    addAuthor(author: string) {
        author = author.trim();
        if (!author) return;
        this._lists.update(curr => {
            const base = curr ?? ({ authors: [], keys: [] } as unknown as ListModel);
            const nextAuthors = base.authors ?? [];
            if (nextAuthors.includes(author)) return base;
            return { ...base, authors: [...nextAuthors, author] };
        });
    }

    /** Imposta keys dal resolver (dedup + copia) */
    setKeys(keys: string[]) {
        const unique = Array.from(new Set((keys ?? []).map(k => k.trim()).filter(Boolean)));
        this._lists.update(curr => {
            const base = curr ?? ({ authors: [], keys: [] } as unknown as ListModel);
            return { ...base, keys: unique };
        });
    }

    /** Aggiungi una singola key (opzionale) */
    addKey(key: string) {
        key = key.trim();
        if (!key) return;
        this._lists.update(curr => {
            const base = curr ?? ({ authors: [], keys: [] } as unknown as ListModel);
            const ks = base.keys ?? [];
            if (ks.includes(key)) return base;
            return { ...base, keys: [...ks, key] };
        });
    }
}
